<script>
import Service from '../../../services/calculator';
import EquipmentOperationService from '../../../services/equipment-operation';
import Utils from '../../../common/Utils'

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import CalculatorInput from './CalculatorInput.vue';
import CalculatorDischargeInput from './CalculatorDischargeInput.vue';
import CalculatorResult from './CalculatorResult.vue';
import CalculatorDischargeResult from './CalculatorDischargeResult.vue';
import ResponsiveButton from '../../generic/ResponsiveButton.vue'
import PIInterface from './PIInterface.vue';
import LimsInterface from './LimsInterface.vue';
import { errorMessages } from '@vue/compiler-sfc';

export default{
    props: ['disableImport', 'inputData'],
    components: {
        TabView, TabPanel, ResponsiveButton,
        CalculatorInput, CalculatorDischargeInput, CalculatorResult, CalculatorDischargeResult,
        PIInterface, LimsInterface
    },
    data(){
        return {
            errorMessage : ""
        }
    },
    watch: {
        inputData(value){
            this.populateInput(value)
        }
    },
    computed: {
        importInOperationDisabled(){
            if(this.disableImport == undefined){
                return false;
            }
            return this.disableImport;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        onLevelCalculate(data){
            this.errorMessage = "";
            let req = {...data};
            req.calculationType = "LVL";
            req.managementType =  this.$refs.levelInput.managementType;  //  data.managementType == 'Promiscous' ? 'PROMISCOUS' : 'NORMAL';

            this.$store.dispatch("generic/setLoading", true);
            Service.calculation(req, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    if(response.data.success){
                        this.$refs.levelResults.loadResults(response.data);
                    }else{
                        if(response.data.askPromiscuousCalculationMode){
                            this.$confirm.require({
                                message: this.$t('messages.promiscousTankCalculator'),
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: this.$t('yes'),
                                rejectLabel: this.$t('no'),
                                accept: () => {
                                    this.$refs.levelInput.managementType = 'PROMISCOUS';
                                    let newData = {...data};
                                    newData.forceManagementType = true;
                                    this.onLevelCalculate(newData);
                                },
                                reject: () => {
                                    let newData = {...data};
                                    newData.forceManagementType = true;
                                    this.onLevelCalculate(newData);
                                }
                            });
                        }else{
                            this.$toast.add({detail: response.data.errorMessage && response.data.errorMessage != '' ? response.data.errorMessage :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            this.$refs.levelResults.loadResults(response.data);
                        }
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        onMovementCalculate(data, movementData){
            data.calculationType = "LVL";
            data.managementType = "NORMAL";
            data.simulationMovedWeight = movementData.simulationMovedWeight;
            if(movementData.movementType == 'I'){
                data.isExtractionSimulation = false;
                data.isIntroductionSimulation = true;
            }else{
                data.isExtractionSimulation = true;
                data.isIntroductionSimulation = false;
            }
                
            this.$store.dispatch("generic/setLoading", true);
            Service.calculation(data, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    if(response.data.success){
                        this.$refs.movementResults.loadResults(response.data);
                    }else{
                        this.$toast.add({detail: response.data.errorMessage && response.data.errorMessage != '' ? response.data.errorMessage :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        onDischargeCalculate(data){
            data.calculationType = "DIS";
            data.managementType = "NORMAL";

            this.$store.dispatch("generic/setLoading", true);
            Service.calculation(data, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    if(response.data.success){
                        this.$refs.dischargeResults.loadResults(response.data);
                    }else{
                        this.$toast.add({detail: response.data.errorMessage && response.data.errorMessage != '' ? response.data.errorMessage :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        populateInput(data){
            this.$refs.levelInput.populateInput(data);
            this.$refs.movementInput.populateInput(data);
            this.$refs.dischargeInput.populateInput(data);
        },
        importLevel(){
            let inputData = this.$refs.levelInput.getInputData();
            let outputData = this.$refs.levelResults.getResults();
            let data = {
                fiscalMovedVolume: null,
                fiscalMovedWeight: null,
                fiscalStockVolume: null,
                fiscalStockWeight: null,
                grossVolume: outputData.totalVolume,
                stockVolume: outputData.netVolume,
                stockVolume15: outputData.volume15,
                stockWeight: outputData.totalWeight,
                roofWeight: inputData.roofWeight,

                tankCode: inputData.tankCode,
                density15: outputData.density15,
                environmentTemperature: inputData.environmentTemperature,
                emptyStockWeight: outputData.vacuumWeight,
                fX54: outputData.f54,
                fX56: outputData.f56,
                biofeedWeightCorrectiornFactor: outputData.biofeedWeightCorrectiornFactor,
                feetPosition: inputData.feetPosition,
                gasPressure: outputData.gasPressure,
                gasTemperature: outputData.gasTemperature,
                idRegistryProduct: inputData.productId,
                introducedGrossVolume: null,
                introducedGrossWeight: null,
                isGas: outputData.isGas,
                managementType: ( this.$refs.levelInput.managementType == 'PROMISCOUS' ||  this.$refs.levelInput.managementType == 'Promiscous') ? 'Promiscous' : 'Pure Product',
                measureType: "LEVEL",
                molecularWeight: outputData.molecularWeight,
                movedVolume: outputData.movedVolume,
                movedWeight: outputData.movedWeight,
                operationDate: inputData.calculationDate,
                productLevel: outputData.productLevel,
                removableVolume: outputData.removableVolume,
                removableWeight: outputData.removableWeight,
                roofVolume: outputData.roofVolume,
                sampleBarrelDensity15: null,
                shellTemperature: outputData.shellTemperature,
                shellVolume: outputData.shellVolume,
                deltaTemperatura: outputData.deltaShellTemperature,
                steamVolume: outputData.steamVolume,
                steamWeight: outputData.steamWeight,
                sulfurPercentage: outputData.sulfurPercentage,
                temperature: inputData.temperature,
                thermalExpansionFactor: outputData.thermalExpansionFactor,
                waterAndSedimentsCorrectionFactor: outputData.waterAndSedimentsCorrectionFactor,
                waterAndSedimentsIntroducedVolume: outputData.waterAndSedimentsIntroducedVolume,
                waterAndSedimentsVolumePercentage: outputData.waterAndSedimentsVolumePercentage,
                waterLevel: outputData.waterLevel,
                waterVolume: outputData.waterVolume,
                volumeExpansionFactor: outputData.volumeExpansionFactor,
                weightedAverageDensity: null
            }

            this.$emit('populateOperation', data, "TANK");
        },
        importMovement(){
            let inputData = this.$refs.movementInput.getInputData();
            let outputData = this.$refs.movementResults.getResults();

            let data = {
                fiscalMovedVolume: null,
                fiscalMovedWeight: null,
                fiscalStockVolume: null,
                fiscalStockWeight: null,
                grossVolume: outputData.totalVolume,
                stockVolume: outputData.netVolume,
                stockVolume15: outputData.volume15,
                stockWeight: outputData.totalWeight,
                roofWeight: inputData.roofWeight,

                tankCode: inputData.tankCode,
                density15: outputData.density15,
                environmentTemperature: inputData.environmentTemperature,
                emptyStockWeight: null,
                fX54: outputData.f54,
                fX56: outputData.f56,
                biofeedWeightCorrectiornFactor: outputData.biofeedWeightCorrectiornFactor,
                feetPosition: inputData.feetPosition,
                gasPressure: outputData.gasPressure,
                gasTemperature: outputData.gasTemperature,
                idRegistryProduct: inputData.productId,
                introducedGrossVolume: null,
                introducedGrossWeight: null,
                isGas: outputData.isGas,
                managementType: (inputData.managementType == 'PROMISCOUS' || inputData.managementType == 'Promiscous') ? 'Promiscous' : 'Pure Product',
                measureType: "LEVEL",
                molecularWeight: outputData.molecularWeight,
                movedVolume: outputData.movedVolume,
                movedWeight: outputData.movedWeight,
                operationDate: inputData.calculationDate,
                productLevel: outputData.productLevel,
                removableVolume: outputData.removableVolume,
                removableWeight: outputData.removableWeight,
                roofVolume: outputData.roofVolume,
                sampleBarrelDensity15: null,
                shellTemperature: outputData.shellTemperature,
                shellVolume: outputData.shellVolume,
                steamVolume: outputData.steamVolume,
                steamWeight: outputData.steamWeight,
                sulfurPercentage: outputData.sulfurPercentage,
                temperature: inputData.temperature,
                thermalExpansionFactor: outputData.thermalExpansionFactor,
                waterAndSedimentsCorrectionFactor: outputData.waterAndSedimentsCorrectionFactor,
                waterAndSedimentsIntroducedVolume: outputData.waterAndSedimentsIntroducedVolume,
                waterAndSedimentsVolumePercentage: outputData.waterAndSedimentsVolumePercentage,
                waterLevel: outputData.waterLevel,
                waterVolume: outputData.waterVolume,
                weightedAverageDensity: null
            }
            
            this.$emit('populateOperation', data, "TANK");
        },
        importDischarge(){

            let inputData = this.$refs.dischargeInput.getInputData();
            let outputData = this.$refs.dischargeResults.getResults();
            
            let data = {
                fiscalMovedVolume: null,
                fiscalMovedWeight: null,
                fiscalStockVolume: null,
                fiscalStockWeight: null,
                
                grossVolume: outputData.finalLiquidMeasure.grossVolume,
                
                biofeedWeightCorrectiornFactor: null,
                deltaTemperatura: outputData.finalLiquidMeasure.deltaTemperature,
                density15: inputData.density15,
                environmentTemperature: inputData.environmentTemperature,

                tankCode: inputData.tankCode,
                emptyStockWeight: null,
                fX54: outputData.weightedAverageDensity.volumeCorrectionFactor,
                fX56: outputData.weightedAverageDensity.weightCorrectionFactor,
                
                feetPosition: inputData.feetPosition,
                gasPressure: null,
                gasTemperature: null,
                idRegistryProduct: inputData.productId,

                introducedGrossVolume: outputData.netFinalMeasure.introducedVolume,
                introducedGrossWeight: outputData.netFinalMeasure.introducedQuantity,
                isGas: false,
                managementType: (inputData.managementType == 'PROMISCOUS' || inputData.managementType == 'Promiscous') ? 'Promiscous' : 'Pure Product',
                measureType: "LEVEL",
                molecularWeight: null,
                movedVolume: outputData.finalLiquidMeasure.movedVolume,
                movedWeight: outputData.finalLiquidMeasure.movedWeight,
                operationDate: inputData.calculationDate,
                productLevel: inputData.productLevel,
                removableVolume: outputData.finalLiquidMeasure.removableVolume,
                removableWeight: outputData.finalLiquidMeasure.removableWeight,
                roofVolume: outputData.finalLiquidMeasure.roofVolume,
                sampleBarrelDensity15: inputData.sampleBarrelData.density15SampleBarrel,
                shellTemperature: outputData.finalLiquidMeasure.shellTemperature,
                shellVolume: outputData.finalLiquidMeasure.shellVolume,
                steamVolume: null,
                steamWeight: null,
                stockVolume: outputData.initialMeasureRecalculated.netVolume,
                stockVolume15: outputData.netFinalMeasure.volume15,
                stockWeight: outputData.finalLiquidMeasure.stockWeight,

                sulfurPercentage: outputData.finalLiquidMeasure.sulfurPercentage,
                temperature: inputData.temperature,
                thermalExpansionFactor: outputData.finalLiquidMeasure.thermalExpansionFactor,
                waterAndSedimentsCorrectionFactor: outputData.netFinalMeasure.waterAndSedimentsCorrectionFactor,
                waterAndSedimentsIntroducedVolume: outputData.netFinalMeasure.waterAndSedimentsIntroducedVolume,
                waterAndSedimentsVolumePercentage: outputData.netFinalMeasure.waterAndSedimentsVolumePercentage,
                waterLevel: inputData.waterLevel,
                waterVolume: outputData.finalLiquidMeasure.waterVolume,
                weightedAverageDensity: outputData.weightedAverageDensity.averageDensity15,
                
                roofWeight: inputData.roofWeight
            }
            
            this.$emit('populateOperation', data, "DISCHARGE");
        },
        loadPreviousOperation(inputData){
            let body = {
                tankCode: inputData.tankCode,
                date: inputData.calculationDate
            }
            
            EquipmentOperationService.getLastOperation(body, response => {
                if(response.success){
                    let lastOperation = response.data;
                    if(lastOperation){

                        let d = {...response.data};
                        d.totalVolume = d.grossVolume;
                        d.volume15 = d.stockVolume15;
                        d.totalWeight = d.stockWeight;
                        d.f54 = d.fX54;
                        d.f56 = d.fX56;
                        d.netVolume = d.grossVolume - d.waterVolume;
                        this.$refs.prevMovementResults.loadResults(d);
                    }
                }
            })
        
        },
        exportPDF(type){

            if(type == 'level'){
                let data = this.$refs.levelInput.getInputData();
                data.calculationType = "LVL";
                // data.managementType = data.managementType == 'Promiscous' ? 'PROMISCOUS' : 'NORMAL';
                let managementType = this.$refs.levelInput.getManagementType();
                if(managementType == 'Promiscous' || managementType == 'PROMISCOUS'){
                    data.managementType = 'Promiscous';
                }else{
                    data.managementType = 'Normal'
                }

                let results =  this.$refs.levelResults.getResults();
                let body = {
                    tankCalculationInput: data,
                    tankCalculationOutput: results
                }

                let fileName =  `LEVEL_${data.tankCode}_${Utils.formatDateTime(data.calculationDate)}`;

                this.$store.dispatch("generic/setLoading", true);
                Service.exportLevel(body, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.downloadDocument(response.data, fileName)
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
                
            }else if(type == 'movement'){
                let data = this.$refs.movementInput.getInputData();
                let movementData = this.$refs.movementInput.getMovementData();

                data.calculationType = "LVL";
                data.managementType = "NORMAL";
                data.simulationMovedWeight = movementData.simulationMovedWeight;
                if(movementData.movementType == 'I'){
                    data.isExtractionSimulation = false;
                    data.isIntroductionSimulation = true;
                }else{
                    data.isExtractionSimulation = true;
                    data.isIntroductionSimulation = false;
                }


                let prevResults =  this.$refs.prevMovementResults.getResults();
                let results =  this.$refs.movementResults.getResults();
                let body = {
                    tankCalculationInput: data,
                    tankCalculationOutput: { ...prevResults, ...results }
                }

                let fileName =  `MOVEMENT_${data.tankCode}_${Utils.formatDateTime(data.calculationDate)}`;

                this.$store.dispatch("generic/setLoading", true);
                Service.exportMovement(body, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.downloadDocument(response.data, fileName)
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
                
            }else if(type == 'discharge'){
                let data = this.$refs.dischargeInput.getInputData();
                data.calculationType = "DIS";
                data.managementType = "NORMAL";


                let results =  this.$refs.dischargeResults.getResults();
                let body = {
                    tankCalculationInput: data,
                    tankCalculationOutput: results
                }
                
                let fileName =  `DISCHARGE_${data.tankCode}_${Utils.formatDateTime(data.calculationDate)}`;
                this.$store.dispatch("generic/setLoading", true);
                Service.exportDischarge(body, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.downloadDocument(response.data, fileName)
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
                
            }

        },
        downloadDocument(id, name){
            this.$store.dispatch("generic/setLoading", true);
            Service.print(id, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', name + '.pdf');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        }
    }
}
</script>

<template>
    <main>
        <TabView>
            <TabPanel :header="$t('tankCalculator.level')">
                <div class="grid">
                    <div class="col-12 lg:col-4">
                        <CalculatorInput ref="levelInput" :executeCalculation="onLevelCalculate" :movementCalculation="false" />
                    </div>
                    <div class="col-12 lg:col-8">
                        <ResponsiveButton :label="$t('tankOperations.importInOperation')" icon="pi pi-table" class="p-button-sm m-2" @click="importLevel" :disabled="!uiPermissions('tankCalculatorExportButton').isEnabled || importInOperationDisabled"/>
                        <ResponsiveButton :label="$t('calculatorTankDevelopment.export')" icon="pi pi-file-pdf" class="p-button-sm m-2" @click="exportPDF('level')" />
                        <Message severity="error" :closable="false" v-if="errorMessage">{{ errorMessage }}</Message>
                        <CalculatorResult ref="levelResults" :title="$t('calculatorTankDevelopment.result')" :columns="3"/>
                    </div>
                </div>
            </TabPanel>
            <TabPanel :header="$t('tankCalculator.movement')">
                <div class="grid">
                    <div class="col-12 lg:col-4">
                        <CalculatorInput ref="movementInput" :executeCalculation="onMovementCalculate" :movementCalculation="true" @load-prev-operation="loadPreviousOperation" />
                    </div>
                    <div class="col-12 lg:col-4">
                        <CalculatorResult ref="prevMovementResults" :title="$t('calculatorTankDevelopment.start')" :columns="2"/>
                    </div>
                    <div class="col-12 lg:col-4">
                        <ResponsiveButton :label="$t('tankOperations.importInOperation')" icon="pi pi-table" class="p-button-sm m-2" @click="importMovement" :disabled="!uiPermissions('tankCalculatorExportButton').isEnabled || importInOperationDisabled"/>
                        <ResponsiveButton :label="$t('calculatorTankDevelopment.export')" icon="pi pi-file-pdf" class="p-button-sm m-2" @click="exportPDF('movement')" />
                        <CalculatorResult ref="movementResults" :title="$t('calculatorTankDevelopment.end')" :columns="2"/>
                    </div>
                </div>
            </TabPanel>
            <TabPanel :header="$t('tankCalculator.discharge')">
                <div class="grid">
                    <div class="col-12 lg:col-4">
                        <CalculatorDischargeInput ref="dischargeInput" :executeCalculation="onDischargeCalculate"/>
                    </div>
                    <div class="col-12 lg:col-8">
                        <ResponsiveButton :label="$t('tankOperations.importInOperation')" icon="pi pi-table" class="p-button-sm m-2" @click="importDischarge" :disabled="!uiPermissions('tankCalculatorExportButton').isEnabled || importInOperationDisabled"/>
                        <ResponsiveButton :label="$t('calculatorTankDevelopment.export')" icon="pi pi-file-pdf" class="p-button-sm m-2" @click="exportPDF('discharge')" />
                        <CalculatorDischargeResult ref="dischargeResults" />
                    </div>
                </div>
            </TabPanel>
            <TabPanel :header="$t('calculatorTankDevelopment.PIInterface')">
                <div class="grid">
                    <div class="col-offset-3 col-6">
                        <PIInterface />
                    </div>
                </div>
            </TabPanel>
            <TabPanel :header="$t('calculatorTankDevelopment.LimsInterface')">
                <LimsInterface />
            </TabPanel>
        </TabView>
    </main>
</template>